<template>
<div>
<bookCourse/>

</div>
</template>

<script>
import BookCourse from '../../components/academic/BookCourse.vue';



export default {
  components: {
 
    BookCourse
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>